import React from 'react';
import { Container, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import CourseNavigation from '../components/CourseNavigation/CourseNavigation';
import ModuleViewer from '../components/ModuleViewer/ModuleViewer';

const ModulePage: React.FC = () => {
  const { courseId, moduleId } = useParams<{ courseId: string; moduleId: string }>();

  if (!courseId || !moduleId) {
    return (
      <Container maxWidth='lg' sx={{ py: 4 }}>
        <Typography variant='h4'>Module not found</Typography>
      </Container>
    );
  }

  return (
    <>
      <CourseNavigation currentPage='module' />
      <ModuleViewer courseId={courseId} moduleId={moduleId} />
    </>
  );
};

export default ModulePage;
